import request from '@/utils/request'

export const login = (data) => {
  return request({
    url: '/login',
    method: 'post',
    data
  })
}

export const logout = (data) => {
  return request({
    url: '/logout',
    method: 'post',
    data
  })
}
